import { sdk } from '@needful-things-mvp/sdk';

import { USE_MOCK } from './data-mode';
import { unwrap } from './http';
import { delay } from './mock';

export interface DashboardTotals {
  projects: number;
  liveVoting: number;
  voterEmails: number;
  subscribers: number;
}

export interface LiveVotingRow {
  project: string;
  projectSlug: string;
  closesAt: string | null;
  votes: number;
  leading: string | null;
  leadingSlug: string | null;
}

export interface DashboardData {
  totals: DashboardTotals;
  liveVoting: LiveVotingRow[];
}

/**
 * Mirrors `GET /admin/dashboard`: aggregate counts plus the projects currently
 * open for voting. Replace the body with the Treaty call to switch to the API.
 */
export async function getDashboard(): Promise<DashboardData> {
  if (!USE_MOCK) {
    return unwrap<DashboardData>(await sdk.api.admin.dashboard.get());
  }

  await delay();
  return {
    totals: {
      projects: 12,
      liveVoting: 3,
      voterEmails: 1204,
      subscribers: 486,
    },
    liveVoting: [
      {
        project: 'Bloom',
        projectSlug: 'bloom',
        closesAt: '2026-10-12T00:00:00.000Z',
        votes: 1832,
        leading: 'Mara Oliveira',
        leadingSlug: 'mara-oliveira',
      },
      {
        project: 'Salt & Iron',
        projectSlug: 'salt-and-iron',
        closesAt: '2026-10-18T00:00:00.000Z',
        votes: 1264,
        leading: 'Tomas Beck',
        leadingSlug: 'tomas-beck',
      },
      {
        project: 'Ember Field',
        projectSlug: 'ember-field',
        closesAt: '2026-10-25T00:00:00.000Z',
        votes: 754,
        leading: 'Priya Nair',
        leadingSlug: 'priya-nair',
      },
    ],
  };
}
